import { render, staticRenderFns } from "./commercialisation.vue?vue&type=template&id=647d7db2&scoped=true"
import script from "./commercialisation.vue?vue&type=script&lang=js"
export * from "./commercialisation.vue?vue&type=script&lang=js"
import style0 from "./commercialisation.vue?vue&type=style&index=0&id=647d7db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d7db2",
  null
  
)

export default component.exports